import { Chip } from '@routable/ai';
import { Tooltip, Skeleton } from '@routable/gross-ds';
import { isSectionTypeTable, isFieldTypeText, isFieldTypeTextarea } from '@routable/tablematic';
import clsx from 'clsx';
import _get from 'lodash/get';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { formNamesItem } from 'constants/forms';
import { useOverlaysSourceForFieldValue } from 'hooks';
import { useCreateItemFormContext } from 'modules/dashboard/createItems/createItemForm/components/CreateItemForm/context';
import { createGetFormValuesSelector } from 'selectors/createFormSelectors';
export const FieldWrapper = React.memo(({ Component, ...props }) => {
    const allValues = useSelector(createGetFormValuesSelector(formNamesItem.CREATE_ITEM));
    const { isRestOfFormLoading } = useCreateItemFormContext();
    const fieldPath = props.name;
    const { currentSource, isPredictiveCodingUiEnabled } = useOverlaysSourceForFieldValue(fieldPath);
    const { getIsRequired: { dependencyFieldsPaths }, getIsDisabled: { dependencyFieldsPaths: disabledDependencyFieldPaths }, rowValues, } = props;
    const isSectionTable = isSectionTypeTable(props.section?.sectionType);
    const isFieldTextarea = isFieldTypeText(props.fieldType) || isFieldTypeTextarea(props.fieldType);
    const additionalDependencies = isSectionTable ? [_get(allValues, `${props.sectionPath}.${props.rowIdx}`)] : [];
    const dependencies = useMemo(() => (dependencyFieldsPaths || [])
        .concat(disabledDependencyFieldPaths || [])
        .filter(Boolean)
        .map((depFieldPath) => {
        if (depFieldPath.includes('root.')) {
            const dataPath = depFieldPath.replace('root.', '');
            return _get(allValues, dataPath);
        }
        const dataPath = depFieldPath.replace('data.', '').replace('extended_', 'extended.');
        return _get(rowValues, dataPath);
    })
        .concat(additionalDependencies)
        .filter(Boolean), [additionalDependencies, allValues, dependencyFieldsPaths, disabledDependencyFieldPaths, rowValues]);
    const formValues = useMemo(() => allValues, dependencies);
    const memoProps = useMemo(() => props, dependencies);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "w-full min-h-[40px]" },
            isRestOfFormLoading && (React.createElement("div", { className: clsx('w-full', { 'px-4': isSectionTable && isFieldTextarea }) },
                React.createElement(Skeleton, { className: "min-w-full", size: isSectionTable ? 'small' : 'large' }))),
            isPredictiveCodingUiEnabled && currentSource && isSectionTable && (React.createElement(Tooltip, { "data-testid": `data-source-tooltip-${props.name}`, tooltip: currentSource, variant: "dark" },
                React.createElement(Chip, { className: "absolute top-0 left-0 z-10" }))),
            React.createElement("div", { className: clsx('w-full', { hidden: isRestOfFormLoading }) },
                React.createElement(Component, { ...memoProps, formValues: formValues })))));
});
